// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b2907d03","453":"e16c3784","796":"594e4676"}[chunkId] + ".chunk.js";
};